import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';

import {
  HeaderFavorites,
  HeaderLogo,
  HeaderNavDesktop,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

import styles from './withOneLineContentNavRight.module.scss';

const HeaderWithOneLineContentNavRightDesktop = () => (
  <HeaderRow borderless className={styles.header_row} type="medium">
    <HeaderSection justify="start">
      <HeaderLogo fullWidth />
      <StoreLocator />
      <MedRecSwitch />
    </HeaderSection>
    <HeaderSection className={styles.nav_section} justify="start">
      <HeaderNavDesktop />
    </HeaderSection>
    <HeaderSection justify="end">
      <SearchHeader withEmbeddedInput />
      <HeaderProfile />
      <HeaderFavorites />
      <HeaderShopping />
    </HeaderSection>
  </HeaderRow>
);

export { HeaderWithOneLineContentNavRightDesktop };
